<template>
  <div>
    <div class="side-frame-success">
      <span style="font-size: 14px; color: #606266">{{
        $l('tips_title_sample_table') || '样品信息'
      }}</span>
    </div>
  </div>
</template>
<script>
const initForm = {
  keyword: '',
}

export default {
  props: {
    disabled: {type: Boolean, default: true},
  },
  data() {
    return {
      form: {...initForm},
    }
  },
  created() {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
